export default "__VITE_ASSET__424db29f__"